"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const pulse_components_1 = require("@pcs/pulse-components");
const clsx_1 = __importDefault(require("clsx"));
const lodash_1 = require("lodash");
const utilities_1 = require("jsAssets/utilities");
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const NotificationUsersOptions = (props) => {
    const { users, onCheckOption, onSelectAllOption, onSearchOption } = props;
    const [options, setOptions] = (0, react_1.useState)(users);
    const [filterText, setFilterText] = (0, react_1.useState)('');
    const [selectedUsers, setSelectedUsers] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        setOptions(onSearchOption(filterText));
        const listSelected = users.filter((user) => {
            return user === null || user === void 0 ? void 0 : user.selected;
        });
        setSelectedUsers(listSelected);
    }, [users]);
    const onChangeFilterUsers = (0, lodash_1.debounce)((e) => {
        setFilterText(e.target.value);
        setOptions(onSearchOption(e.target.value));
    }, 500);
    const onSelectAll = () => {
        onSelectAllOption();
    };
    const onCheckNotifyUser = (e, user) => {
        if (e.target === e.currentTarget) {
            onCheckOption(user);
        }
    };
    return (react_1.default.createElement("div", { className: styles_modules_less_1.default['notification-users-options__root'] },
        react_1.default.createElement("div", { className: styles_modules_less_1.default['notification-users-options__header'] },
            react_1.default.createElement("div", { className: styles_modules_less_1.default['notification-users-options__header--input'] },
                react_1.default.createElement(pulse_components_1.PulseInput, { InputBaseProps: {
                        classes: {
                            root: styles_modules_less_1.default['header-input__root'],
                            input: styles_modules_less_1.default['header-input__input'],
                        },
                        placeholder: 'Filter Reviewers...',
                        onChange: onChangeFilterUsers,
                    } })),
            react_1.default.createElement("div", { className: styles_modules_less_1.default['header__select-option'] },
                react_1.default.createElement("label", { className: styles_modules_less_1.default['header__select-option--label'] },
                    "Notify (",
                    selectedUsers.length,
                    ")"),
                react_1.default.createElement("span", { className: styles_modules_less_1.default['header__select-option--all'], onClick: onSelectAll }, "Select all"))),
        react_1.default.createElement("div", { className: styles_modules_less_1.default['notification-users-options__body'] }, options.map((user) => {
            const convertUser = (0, utilities_1.camelizeKeys)(user);
            return (react_1.default.createElement("div", { key: user.id, className: styles_modules_less_1.default['user-option'] },
                react_1.default.createElement("div", { className: styles_modules_less_1.default['user-option__user'] },
                    react_1.default.createElement("div", { className: styles_modules_less_1.default['user-option__info'] },
                        react_1.default.createElement("img", { className: styles_modules_less_1.default['user-option__avatar'], src: `${convertUser === null || convertUser === void 0 ? void 0 : convertUser.avatarUrl}`, alt: user.name }),
                        react_1.default.createElement("div", { className: styles_modules_less_1.default['user-option__text'] },
                            react_1.default.createElement("div", { className: styles_modules_less_1.default['user-option__name'] }, user.name),
                            react_1.default.createElement("div", { className: styles_modules_less_1.default['user-option__role'] }, user.role || '')))),
                react_1.default.createElement("div", { className: (0, clsx_1.default)(styles_modules_less_1.default['user-option__selection'], user.selected && styles_modules_less_1.default['user-option__selection--selected']), onClick: (e) => {
                        onCheckNotifyUser(e, user);
                    } },
                    react_1.default.createElement("input", { className: styles_modules_less_1.default['user-option__selection--checkbox'], type: "checkbox", name: user.name, checked: (user === null || user === void 0 ? void 0 : user.selected) || false, onChange: (e) => {
                            onCheckNotifyUser(e, user);
                        } }))));
        }))));
};
exports.default = NotificationUsersOptions;
